import React from "react";
import { AddSourceAllocationContainer } from "../../../containers";

const AddSourceAllocation = (props) => {
  return <AddSourceAllocationContainer {...props} />;
};

export default AddSourceAllocation;
